// 合并所有翻译资源
import { layoutResources } from './layout';
import { newsResources } from './news';
import { applyResources } from './apply';
import { projectsResources } from './projects';
import { homeResources } from './home';
import { aboutusResources } from './aboutus';
import { applicationFormResources } from './applicationForm';
import { privacyPolicyResources } from './privacyPolicy';
import { termsOfServiceResources } from './termsOfService';

// 合并资源的辅助函数
const mergeResources = (...resources) => {
  const languages = ['zh', 'zh_TW', 'en'];
  const merged = {};
  
  languages.forEach(lang => {
    merged[lang] = {
      translation: {}
    };
    
    resources.forEach(resource => {
      if (resource[lang]) {
        Object.assign(merged[lang].translation, resource[lang]);
      }
    });
  });
  
  return merged;
};

// 导出合并后的资源
export const resources = mergeResources(
  layoutResources,
  newsResources,
  applyResources,
  projectsResources,
  homeResources,
  aboutusResources,
  applicationFormResources,
  privacyPolicyResources,
  termsOfServiceResources
);

